import { useState, type MouseEventHandler } from "react";
import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "./ConfirmationModal";

interface Props {
  tag: string;
  onUpdate?: (tag: string) => void;
  onClick?: MouseEventHandler<HTMLElement>;
  useConfirmationDialogue?: boolean;
  actionType?: "add" | "remove";
  showActionIcon?: boolean;
  taggedItemDescription?: string;
}

const CustomTag = ({
  tag,
  onUpdate = () => {},
  onClick = () => {},
  useConfirmationDialogue,
  actionType = "remove",
  showActionIcon = false,
  taggedItemDescription = "item",
}: Props) => {
  const { t } = useTranslation(["tags"]);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Badge
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="badge bg-trellis-mauve d-flex"
      style={{
        marginRight: "1rem",
        cursor: "pointer",
      }}
      pill
      onClick={onClick}
    >
      {tag}
      {useConfirmationDialogue ?
        <ConfirmationModal
          title={t(($) => $.tags.customTag["Confirm Tag Update"])}
          confirmButtonText={t(($) => $.tags.customTag["Confirm"])}
          confirmationMessage={
            <p className="fs-3 w-75 mx-auto">
              {t(($) => $.tags.customTag["Are you sure you want to remove this tag from this {description}?"], {
                description: taggedItemDescription,
              })}
            </p>
          }
          onConfirm={() => onUpdate(tag)}
          modelButtonStyle={{ margin: 0 }}
          inlineModal={true}
          modalButtonText={
            <i
              className={`fa ${actionType === "add" ? "fa-plus" : "fa-close"} ps-1`}
              style={{ width: "10px", display: isHovered ? "inline" : "none" }}
            />
          }
        />
      : <i
          onClick={() => onUpdate(tag)}
          className={`fa ${actionType === "add" ? "fa-plus" : "fa-close"} ps-1`}
          style={{
            width: "10px",
            position: "relative",
            display: isHovered || showActionIcon ? "inline" : "none",
          }}
        />
      }
    </Badge>
  );
};

export default CustomTag;
